
export interface LegalTableEntityDTO {
  content: string;
  id?: number;
  status: string;
  title: string;
  dateCreated?: string;
}

export enum LegalTableSortProps {
  TITLE = 'title',
  DATE = 'date',
  PUBLISHED = 'published',
  CONTENT = 'content',
}

export enum LegalStatuses {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED'
}